import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { InvoiceTracking } from "../invoiceTracking/Table";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { JVDate } from "../../shared/JVDate";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { getDates } from "../../shared/GetInvDates";
import { PaymentTerm } from "../../models/ConsultantMast";
import { Card } from "primereact/card";
import { SVInvoiceAdditionalExpenses } from "./SVInvoiceAdditionalExpenses";

interface IProps {
    open: boolean,
    singleData: any,
    onHide: () => void,
    toast: any,
    recent: any
}

export interface ISubvendorInvoice {
    id?: number,
    primevendorInvoice_ID?: number,
    pO_ID?: number,
    invoiceNO?: string,
    requestedAmount?: number,
    paymentStatus?: string,
    paidAmount?: number,
    payment_Mode?: string,
    transaction_ID?: string,
    fromDate?: Date,
    toDate?: Date,
    workingHours?: number,
    dueDate?: Date,
    subvendorCompany_ID?: {
        vendor_Company_ID: number,
        vendor_Company_Name: string,
    },
    consultant_ID?: {
        consultant_ID: number,
        pO_ID: number,
    },
    bRate?: number,
    recivedDate?: Date,
    isVerfied?: boolean,
    deduction?: number,
    remarks?: string,
}

export interface IGetDateProps {
    po: any,
    recent: any,
    singleData: any,
}

const schema = yup.object({
    subvendorCompany_ID: yup.object({
        vendor_Company_ID: yup.number().required(""),
        vendor_Company_Name: yup.string().required(""),
    }).required("Subvendor is Required"),
    //consultant_ID: yup.number().required("Consultant is Required"),
    consultant_ID: yup.object({
        consultant_ID: yup.number().required(""),
        pO_ID: yup.number().required(""),
    }).required("Consultant is Required"),
    invoiceNO: yup.string().required("Invoice NO is Required"),
    requestedAmount: yup.number().required("Invoice Amount is required"),
    paymentStatus: yup.string().nullable(),
    primevendorInvoice_ID: yup.number().when('paymentStatus', val => {
        return (val === undefined || val === null || val === "Pending" || val === "" || val === "In Process") ?
            yup.number().nullable() :
            yup.number().required("Primevendor Invoice Number is Required")
    }),
    paidAmount: yup.number().nullable(),
    payment_Mode: yup.string().nullable(),
    transaction_ID: yup.string().nullable(),
    fromDate: yup.date().required("From Date is Required"),
    toDate: yup.date().required("To Date is Required"),
    workingHours: yup.number().required("Invoice Working Hours is Required"),
    dueDate: yup.date().required("Due Date is Required"),
    isVerfied: yup.boolean().nullable(),
    deduction: yup.number().nullable(),
    remarks: yup.string().nullable(),
});

const EmptyForm: ISubvendorInvoice = {
    primevendorInvoice_ID: 0,
    invoiceNO: '',
    requestedAmount: 0,
    paymentStatus: '',
    paidAmount: 0,
    payment_Mode: '',
    transaction_ID: '',
    workingHours: 0,
    deduction: 0,
}

export const Form = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [allPrimeVendorInvoices, setAllPrimeVendorInvoices] = useState<InvoiceTracking[]>([]);
    const [invoiceFile, setInvoiceFile] = useState<File | null | any>(null);
    const [uploadedInvoice, setUploadedInvoice] = useState(false);
    const [subvendor_List, setSubvendor_List] = useState<any[]>([]);
    const [consultant_List, setConsultant_List] = useState<any[]>([]);
    const [dispFields, setDispFields] = useState({ Consultant: true, Primevendor: true } as { Consultant: boolean, Primevendor: boolean });
    const [svInvAmnt, setSvInvAmnt] = useState<number>(0);
    const [poDetails, setPoDetails] = useState<IPurchaseOrder | null>(null);
    const [additionalExpensesDocList, setAdditionalExpensesDocList] = useState<Array<{ id: any, description: string, hours: number, rate: number, amount: number }>>([]);
    const [additionalExpensesList, setAdditionalExpensesList] = useState<Array<{ id: any, description: string, hours: number, rate: number, amount: number }>>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<ISubvendorInvoice>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const Payment_Status_First = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "In Process", value: "In Process" },
        { name: "Released", value: "Released" },
        { name: "Released In Advance", value: "Released In Advance" },
    ];

    const Payment_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "In Process", value: "In Process" },
        { name: "Released", value: "Released" },
        { name: "Released In Advance", value: "Released In Advance" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const Payment_Mode = [
        { name: "-- SELECT --", value: null },
        { name: "Cheque", value: "CHEQUE" },
        { name: "NetBanking", value: "NET BANKING" },
        { name: "UPI", value: "UPI" },
        { name: "PayPal", value: "PAYPAL" },
        { name: "Direct Deposit", value: "DIRECT DEPOSIT" },
        { name: "Wire Transfer", value: "WIRE TRANSFER" },
        { name: "ACH", value: "ACH" },
    ];

    const onHide = () => {
        reset({});
        setSvInvAmnt(0);
        setPoDetails(null);
        setDispFields({ Consultant: true, Primevendor: true });
        props.onHide();
    };

    const onSubmit = async (data: ISubvendorInvoice) => {
        if (data.requestedAmount !== undefined && data.requestedAmount !== null && data.requestedAmount > 0 && data.requestedAmount > (svInvAmnt + additionalExpensesDocList.reduce((sum, el) => sum + (el.amount || 0), 0))) {
            props.toast.current.show({ severity: 'error', detail: "Description Is Required In All Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.description.trim() === "").length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Description Is Required In All Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.hours === 0).length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Hours Cannot be 0 In Aany Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.rate === 0).length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Rate Cannot be 0 In Aany Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.amount === 0).length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Amount Cannot be 0 In Aany Additional Expenses", life: 3000 });
        } else if (data.paymentStatus === "Paid" && ((data.paidAmount || 0) + (data.deduction || 0)) !== Number(props.singleData?.invoiceAmount || svInvAmnt)) {
            props.toast.current.show({ severity: 'error', detail: "Pay Amount + Deduction dose not match to Invoice Amount and Payment Status", life: 3000 });
        } else if (data.paymentStatus === "Balance" && ((data.paidAmount || 0) + (data.deduction || 0)) >= Number(props.singleData?.invoiceAmount || svInvAmnt)) {
            props.toast.current.show({ severity: 'error', detail: "Pay Amount + Deduction dose not match to Invoice Amount and Payment Status", life: 3000 });
        } else if (data.paymentStatus === "Over Payment" && ((data.paidAmount || 0) + (data.deduction || 0)) <= Number(props.singleData?.invoiceAmount || svInvAmnt)) {
            props.toast.current.show({ severity: 'error', detail: "Pay Amount + Deduction dose not match to Invoice Amount and Payment Status", life: 3000 });
        } else {
            if (invoiceFile === null && (props?.singleData?.id == null || props?.singleData?.id == 0)) {
                props.toast.current.show({ severity: 'error', detail: "Please Upload Subvendor Invoice First", life: 3000 });
            } else {
                let newData: any = {
                    consultant_ID: data?.consultant_ID?.consultant_ID,
                    primevendorInvoice_ID: data.primevendorInvoice_ID,
                    pO_ID: data?.consultant_ID?.pO_ID,
                    invoiceNO: data.invoiceNO,
                    invoiceAmount: svInvAmnt,
                    requestedAmount: data.requestedAmount,
                    paymentStatus: data.paymentStatus,
                    paidAmount: data.paidAmount,
                    payment_Mode: data.payment_Mode,
                    transaction_ID: data.transaction_ID,
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    workingHours: data.workingHours,
                    dueDate: data.dueDate,
                    subvendorCompany_ID: data?.subvendorCompany_ID?.vendor_Company_ID,
                    bRate: poDetails?.bRate,
                    isVerfied: data.isVerfied,
                    generated_Date: data.recivedDate,
                    deduction: data.deduction,
                    remarks: data.remarks,
                };

                let updateData: any = {
                    id: props.singleData.id,
                    invoiceNO: newData.invoiceNO,
                    primevendorInvoice_ID: newData.primevendorInvoice_ID,
                    pO_ID: newData.pO_ID,
                    invoiceAmount: newData.invoiceAmount,
                    fromDate: newData.fromDate,
                    toDate: newData.toDate,
                    dueDate: newData.dueDate,
                    consultant_ID: newData.consultant_ID,
                    requestedAmount: newData.requestedAmount,
                    workingHours: newData.workingHours,
                    subvendorCompany_ID: newData.subvendorCompany_ID,
                    bRate: newData.bRate,
                    paymentStatus: newData.paymentStatus,
                    paidAmount: newData.paidAmount,
                    payment_Mode: newData.payment_Mode,
                    transaction_ID: newData.transaction_ID,
                    isVerfied: newData.isVerfied,
                    generated_Date: newData.recivedDate,
                    deduction: data.deduction,
                    remarks: data.remarks,
                }

                if (data.paymentStatus === "Pending" || data.paymentStatus === "In Process") {
                    newData.paidAmount = 0;
                    newData.payment_Mode = null;
                    updateData.paidAmount = 0;
                    updateData.payment_Mode = null;
                }

                if (uploadedInvoice === false && (props?.singleData?.id == null || props?.singleData?.id == 0)) {
                    props.toast.current.show({ severity: 'error', content: "Please Upload Subvendor Invoice First." });
                } else {
                    const areSame: boolean = JSON.stringify(additionalExpensesDocList) === JSON.stringify(additionalExpensesList);

                    const newDataA: { description: string, hours: number, rate: number, amount: number }[] = additionalExpensesDocList.map((el: { id: any, description: string, hours: number, rate: number, amount: number }) => {
                        return { description: el.description, hours: el.hours, rate: el.rate, amount: el.amount };
                    });

                    const method = (props.singleData?.id != 0 && props.singleData?.id != null) ? "PUT" : "POST";
                    const message = (props.singleData?.id != 0 && props.singleData?.id != null) ? "Updated Successfully" : "Added Successfully";

                    const formData = new FormData();
                    formData.append('file', invoiceFile);
                    formData.append('newInvoice', JSON.stringify((props?.singleData?.id == null || props?.singleData?.id == 0) ? newData : updateData));
                    if (areSame === false) formData.append('additionals', JSON.stringify(newDataA));
                    const params = {
                        method: method,
                        headers: {
                            'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                        },
                        body: formData
                    };

                    const response = await fetch(`${baseUrl}InvoiceTracking/subvendorInvoice`, params);

                    if (response.ok) {
                        const data: any = await response.json();
                        onHide();
                        props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                        reset({});
                    } else {
                        const message2 = await response.text();
                        props.toast.current.show({ severity: 'error', detail: message2, life: 3000 });
                        setLoading(false);
                    }
                }
            }
        }
    };

    const getPrimevendorInvoiceNumber = async (pO_ID?: number, consultant_ID?: number) => {
        let query = null;
        if (pO_ID != null && pO_ID != 0) {
            query = `poID=${pO_ID}&consultant_ID=${consultant_ID}`;
        }
        const response = await Fetch("InvoiceTracking/getallinvoicesByPoID", "GET", null, query, props.toast);
        if (response) {
            const data: InvoiceTracking[] = await response.json();
            setAllPrimeVendorInvoices(data);
            const response2 = await Fetch("InvoiceTracking/getPODetailsByID", "GET", null, query, props.toast);
            if (response2) {
                const poData: IPurchaseOrder[] = await response2.json();
                setPoDetails(poData[0]);
                //setSvInvAmnt(poData[0].bRate * );
            };
        };
    };

    const invoiceUpload = (event: FileUploadHandlerParam) => {
        if (event.files[0]) {
            if (event.files[0].size > 1024 * 1024 * 5) {
                props.toast.current.show({ severity: 'error', content: "File should be less than 5 MB." });
                event.options.clear();
            } else {
                setInvoiceFile(event.files[0]);
                setUploadedInvoice(true);
                props.toast.current.show({ severity: 'success', content: "File Selected" });
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A File." });
            event.options.clear();
        }
    };

    const completeMethodSubvendor = (event: { query: string }) => {
        loadSubvendor(event.query);
    };

    const loadSubvendor = async (query: string) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${query}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            setSubvendor_List(data);
        }
    };

    const loadConsultant = async (query: number) => {
        const response = await Fetch("Dropdown/consultant", "GET", null, `filter=${query}`, null);
        if (response) {
            const data: any = await response.json();
            let newData = data.map((e: any) => {
                e = {
                    consultant_ID: e.consultant_ID,
                    consultant_Name: e.consultant_Name,
                    pO_ID: e.pO_ID,
                };
                return e;
            });
            console.log(newData);
            setConsultant_List(newData);
        }
    };

    const selectedPrimeVendorInvoiceTemplate = (option: any, props?: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.invoiceNO.split("( ")[0]}<span style={{ color: "#b26bc7" }}>{"( " + option.invoiceNO.split("( ")[1]}</span></div>
                </div>
            );
        }

        return <span>{props.invoiceNO}</span>;
    };

    const primeVendorInvoiceOptionTemplate = (option: any) => {
        return (
            <div className="flex align-items-center">
                <div>{option.invoiceNO.split("( ")[0]}<span style={{ color: "#b26bc7" }}>{"( " + option.invoiceNO.split("( ")[1]}</span></div>
            </div>
        );
    };

    const getPODetails = async (pO_ID: number) => {
        const response = await Fetch("vwPODetailsExternalUser", "GET", null, `byPOID=${pO_ID}`, null);
        if (response) {
            const data: any = await response.json();
            return data[0];
        }
    }

    const getTimesheetHours = async (fromDate: Date, toDate: Date) => {

        const response = await Fetch("Timesheet/getTimesheetHours", "POST", {
            PO_ID: props.singleData.pO_ID,
            FromDate: fromDate,
            ToDate: toDate
        }, null, null);

        if (response) {
            const data: any = await response.json();

            setValue('workingHours', data.hours);
            setSvInvAmnt(prev => prev = (Number(data.hours || 0) * (poDetails?.bRate || props.singleData.bRate || 0)));
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "fromDate") {
                if (value.fromDate != null) {
                    getTimesheetHours(value.fromDate, control._formValues.toDate);
                }
            }
            if (name === "toDate") {
                if (value.toDate != null) {
                    getTimesheetHours(control._formValues.fromDate, value.toDate);
                }
            }
            if (name === "subvendorCompany_ID") {
                if (value.subvendorCompany_ID?.vendor_Company_ID != null && value.subvendorCompany_ID?.vendor_Company_ID != 0) {
                    loadConsultant(value?.subvendorCompany_ID?.vendor_Company_ID || 0);
                    setDispFields(prev => prev = { ...dispFields, Consultant: false });
                } else {
                    setValue("consultant_ID", {
                        consultant_ID: 0,
                        pO_ID: 0,
                    });
                    setDispFields(prev => prev = { ...dispFields, Consultant: true });
                }
            }
            if (name === "consultant_ID") {
                if (value.consultant_ID != null && value.consultant_ID.consultant_ID != 0) {
                    setDispFields(prev => prev = { Consultant: false, Primevendor: false });
                    getPrimevendorInvoiceNumber(value.consultant_ID?.pO_ID, value.consultant_ID.consultant_ID);
                } else {
                    setDispFields(prev => prev = { ...dispFields, Primevendor: true });
                }
            }
            if (name === "workingHours") {
                if (value.workingHours != null && value.workingHours != 0) {
                    setSvInvAmnt(prev => prev = (Number(value?.workingHours || 0) * (poDetails?.bRate || 0)));
                } else setSvInvAmnt(0);
            }
            if (name === "requestedAmount") {
                if (value.requestedAmount != null && value.requestedAmount != 0) {
                    if (value.requestedAmount > (svInvAmnt + additionalExpensesDocList.reduce((sum, el) => sum + (el.amount || 0), 0))) {
                        setError("requestedAmount", { message: "Requested Amount can not be greater than Invoice Amount" }, { shouldFocus: true });
                    } else {
                        setError("requestedAmount", { message: "" }, { shouldFocus: false });
                    }
                }
            }
            if (name === "paidAmount") {
                if (value.paidAmount != null && value.paidAmount !== 0) {
                    if (value.paidAmount === svInvAmnt) {
                        setValue("paymentStatus", "Paid");
                    } else if (value.paidAmount < svInvAmnt) {
                        setValue("paymentStatus", "Balance");
                    } else if (value.paidAmount > svInvAmnt) {
                        setValue("paymentStatus", "Over Payment");
                    }
                }
            }
            if (name === "recivedDate") {
                if (value.recivedDate !== null) {
                    let newDueDate = null;
                    value.recivedDate = new Date(value.recivedDate || "");
                    if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Thirty) {
                        // props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date(new Date()).getDate() + 30));
                        newDueDate = new Date(new Date(value.recivedDate).setDate(new Date(value.recivedDate).getDate() + 29));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Forty_Five) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 45));
                        newDueDate = new Date(new Date(value.recivedDate).setDate(new Date(value.recivedDate).getDate() + 44));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Pay_On_Pay) {
                        //props.singleData.dueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Fifteen) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 15));
                        newDueDate = new Date(new Date(value.recivedDate).setDate(new Date(value.recivedDate).getDate() + 14));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Sixty) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 60));
                        newDueDate = new Date(new Date(value.recivedDate).setDate(new Date(value.recivedDate).getDate() + 59));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Seven) {
                        // props.singleData.dueDate = new Date(new Date().setDate(new Date().getDate() + 7));
                        newDueDate = new Date(new Date(value.recivedDate).setDate(new Date(value.recivedDate).getDate() + 6));
                    };
                    setValue("dueDate", newDueDate || new Date());
                }
            }
        });
        return () => subscription.unsubscribe();

    }, [watch, poDetails, svInvAmnt]);

    const loadAdditionalExpenses = async (id: number) => {
        const response = await Fetch("InvoiceTracking/getAdditionalExpenses", "GET", null, `invoiceID=${id}`, null);
        if (response) {
            const data: any = await response.json();
            setAdditionalExpensesDocList(data);
            setAdditionalExpensesList(data);
        }
    }

    useEffect(() => {
        if (props.open) {
            if (props.singleData.id != null && props.singleData.id != 0) {
                loadAdditionalExpenses(props.singleData.id);
            }

            if (props.singleData.id != null && props.singleData.id != 0) {
                loadConsultant(props.singleData.sub_Vendor_ID || props.singleData.vendor_Company_ID || 0);
                let subvendorID = {
                    vendor_Company_ID: props.singleData.vendor_Company_ID,
                    vendor_Company_Name: props.singleData.vendor_Company_Name,
                };
                let consultantID = {
                    consultant_ID: props.singleData.consultant_ID,
                    consultant_Name: props.singleData.consultant_Name + ` ( ${props.singleData.primeVendor_Company_Name} )`,
                    pO_ID: props.singleData.pO_ID,
                };
                let invData = {
                    id: props.singleData.id,
                    invoiceNO: props.singleData.invoiceNO,
                    invoiceAmount: props.singleData.invoiceAmount,
                    primevendorInvoice_ID: props.singleData.primevendorInvoice_ID,
                    pO_ID: props.singleData.pO_ID,
                    fromDate: new Date(props.singleData.fromDate),
                    toDate: new Date(props.singleData.toDate),
                    dueDate: new Date(props.singleData.dueDate),
                    consultant_ID: consultantID,
                    requestedAmount: props.singleData.requestedAmount,
                    workingHours: props.singleData.workingHours,
                    subvendorCompany_ID: subvendorID,
                    bRate: props.singleData.bRate,
                    paymentStatus: props.singleData.paymentStatus,
                    paidAmount: props.singleData.paidAmount,
                    payment_Mode: props.singleData.payment_Mode,
                    transaction_ID: props.singleData.transaction_ID,
                    isVerfied: props.singleData.isVerfied,
                    recivedDate: new Date(props.singleData.generated_Date),
                    deduction: props.singleData.deduction !== null && props.singleData.deduction !== undefined ? props.singleData.deduction : 0,
                    remarks: props.singleData.remarks,
                };
                getPrimevendorInvoiceNumber(props.singleData.pO_ID, props.singleData.consultant_ID);
                setDispFields({ Consultant: false, Primevendor: false });
                setSvInvAmnt(props.singleData.invoiceAmount);
                if (props.singleData.workHours === null || props.singleData.workHours === undefined) {
                    getTimesheetHours(invData.fromDate, invData.toDate);
                }
                reset(invData);
            } else {
                if (props.singleData?.pO_ID) {
                    let companyDetails: any = getPODetails(props.singleData?.pO_ID);
                    loadConsultant(companyDetails?.sub_Vendor_ID || companyDetails?.vendor_Company_ID || 0);
                    let subvendorID = {
                        vendor_Company_ID: props.singleData.vendor_Company_ID,
                        vendor_Company_Name: props.singleData.vendor_Company_Name,
                    };
                    let consultantID = {
                        consultant_ID: props.singleData.consultant_ID,
                        consultant_Name: props.singleData.consultant_Name + ` ( ${props.singleData.primeVendor_Company_Name} )`,
                        pO_ID: props.singleData.pO_ID,
                    };
                    let invData: any = {
                        id: props.singleData.id,
                        invoiceNO: props.singleData.invoiceNO,
                        invoiceAmount: props.singleData.invoiceAmount,
                        primevendorInvoice_ID: props.singleData.primevendorInvoice_ID,
                        pO_ID: props.singleData.pO_ID,
                        fromDate: null,
                        toDate: null,
                        dueDate: null,
                        recivedDate: null,
                        consultant_ID: consultantID,
                        requestedAmount: props.singleData.requestedAmount,
                        workingHours: props.singleData.workingHours,
                        subvendorCompany_ID: subvendorID,
                        bRate: props.singleData.bRate,
                        paymentStatus: props.singleData.paymentStatus,
                        paidAmount: props.singleData.paidAmount,
                        payment_Mode: props.singleData.payment_Mode,
                        transaction_ID: props.singleData.transaction_ID,
                        isVerfied: props.singleData.isVerfied,
                        deduction: props.singleData.deduction !== null && props.singleData.deduction !== undefined ? props.singleData.deduction : 0,
                        remarks: props.singleData.remarks,
                    };

                    // let data = getDates(); props.po && props.recent.pO_ID && props.po.sub_Vendor_Billing_Cycle
                    //props.po.prime_Vendor_Payment_Term

                    let singleData = invData;

                    let recent = props.recent;

                    let po = {
                        pO_ID: props.singleData.pO_ID,
                        sub_Vendor_Billing_Cycle: props.singleData.sub_Vendor_Billing_Cycle,
                        prime_Vendor_Payment_Term: props.singleData.sub_Vendor_Payment_Term,
                        project_Start_Date: props.singleData.project_Start_Date,
                        project_End_Date: props.singleData.project_End_Date
                    };
                    // let data = getDates({ po, recent, singleData });

                    const values = getDates({ pO_ID: props?.recent?.pO_ID || null, toDate: props?.recent?.toDate ? new Date(props?.recent?.toDate || "") : null }, { Billing_Cycle: props.singleData.sub_Vendor_Billing_Cycle || null, Payment_Term: props.singleData.sub_Vendor_Payment_Term || null, project_Start_Date: new Date(props.singleData.project_Start_Date || ""), project_End_Date: new Date(props.singleData.project_End_Date || ""), timesheet_Week_Start_Day: (props.singleData.timesheet_Week_Start_Day ?? 0) });

                    invData.fromDate = values.FromDate;
                    invData.toDate = values.ToDate;
                    invData.dueDate = values.DueDate;
                    if (props.singleData.workHours === null || props.singleData.workHours === undefined) {
                        getTimesheetHours(invData.fromDate, invData.toDate);
                    }
                    reset(invData);
                    setDispFields({ Consultant: true, Primevendor: true });
                    getPrimevendorInvoiceNumber(props.singleData.pO_ID, props.singleData.consultant_ID);
                } else {
                    reset({});
                    setDispFields({ Consultant: true, Primevendor: true });
                    getPrimevendorInvoiceNumber();
                }
            }
        }
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Subvendor Invoice" modal className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDropdownInput required={true} column={3} completeMethod={completeMethodSubvendor} label="Subvendor" control={control} name="subvendorCompany_ID" error={errors.subvendorCompany_ID?.message} options={subvendor_List} optionLabel="vendor_Company_Name" placeholder="Search Subvendor" />

                    {/* <JVDropdown required disabled={dispFields.Consultant} column={3} label="Consultant" control={control} name="consultant_ID" options={consultant_List} optionLabel="consultant_Name" optionValue="consultant_ID" placeholder="Select Consultant" error={errors.consultant_ID?.message} /> */}
                    <div className={'field col-12 md:col-4'}>
                        <label>Consultant<span style={{ color: 'red' }}>*</span></label>
                        <Controller name={'consultant_ID'} control={control} render={({ field, fieldState }: any) => (
                            <Dropdown inputId={field.name} disabled={dispFields.Consultant} {...field} options={consultant_List} optionLabel={'consultant_Name'} value={field.value} placeholder={"Select Consultant"} className={classNames({ 'p-invalid': fieldState.invalid })} filter={true} />
                        )} />
                        <small className="p-error" >{errors.consultant_ID?.message}</small>
                    </div>
                    <JVDropdown required disabled={dispFields.Primevendor} column={3} label="Primevendor Invoice Number" control={control} name="primevendorInvoice_ID" options={allPrimeVendorInvoices} optionLabel="invoiceNO" optionValue="invoice_ID" placeholder="Select Invoice" itemTemplate={primeVendorInvoiceOptionTemplate} valueTemplate={selectedPrimeVendorInvoiceTemplate} error={errors.primevendorInvoice_ID?.message} />

                    {/* <JVDropdown column={3} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} /> */}
                    <JVDate required column={3} label="Inv Generating Date" control={control} name="recivedDate" error={errors.recivedDate?.message} />
                    <JVDate required column={3} maxDate={new Date()} label="From Date" control={control} name="fromDate" error={errors.fromDate?.message} />
                    <JVDate required column={3} maxDate={new Date()} label="To Date" control={control} name="toDate" error={errors.toDate?.message} />
                    <JVDate required column={3} label="Due Date" control={control} name="dueDate" error={errors.dueDate?.message} />
                    <JVInput required column={3} label="Working Hours" control={control} name="workingHours" error={errors.workingHours?.message} />
                    <div className={'field col-12 md:col-4'}>
                        <label>B. Rate</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.singleData.bRate}</p>
                    </div>
                    <div className={'field col-12 md:col-4'}>
                        <label>Invoice Amount</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{svInvAmnt}</p>
                    </div>
                    <Button style={{ marginLeft: "96%", width: "2rem", height: "2rem" }} icon="pi pi-plus" type="button" tooltip="Click To Add Rowa To Add Additional Exprenses" onClick={() => setAdditionalExpensesDocList([...additionalExpensesDocList, { id: crypto.randomUUID(), description: "", hours: 0, rate: 0, amount: 0 }])} />
                    {additionalExpensesDocList.length > 0 && <Card className={'field col-12 md:col-12'} style={{ width: "98%", marginLeft: "15px" }}>
                        <div className="field col-12 md:col-12 flex">
                            <b>Additional Expenses</b>
                        </div>
                        <div style={{ maxHeight: "30rem", overflowY: "scroll" }}>
                            {additionalExpensesDocList.map(((el: { id: any, description: string, hours: number, rate: number, amount: number }) => <SVInvoiceAdditionalExpenses list={additionalExpensesDocList} setList={setAdditionalExpensesDocList} id={el.id} description={el.description} hours={el.hours} rate={el.rate} amount={el.amount} toast={props.toast} />))}
                        </div>
                    </Card>}
                    <JVInput required column={3} label="Invoice Number" control={control} name="invoiceNO" error={errors.invoiceNO?.message} />
                    <JVInput required column={3} label="Requested Amount" control={control} name="requestedAmount" error={errors.requestedAmount?.message} />
                    <JVDropdown column={3} label="Payment Status" control={control} disabled={control._formValues.paymentStatus === "Paid" || control._formValues.paymentStatus === "Over Payment"} name="paymentStatus" options={(control._formValues.paymentStatus === null || control._formValues.paymentStatus === "Pending" || control._formValues.paymentStatus === "In Process") ? Payment_Status_First : Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} />
                    {(props.singleData.paymentStatus === "Released" || props.singleData.paymentStatus === "Balance") && <JVInput column={3} label="Paid Amount" control={control} name="paidAmount" error={errors.paidAmount?.message} />}
                    <JVInput column={3} label="Deduction" control={control} name="deduction" error={errors.deduction?.message} />
                    {(props.singleData.paymentStatus === "Released" || props.singleData.paymentStatus === "Balance") && <JVDropdown column={3} label="Payment Mode" control={control} name="payment_Mode" options={Payment_Mode} optionLabel="name" optionValue="value" placeholder="Select Payment Mode" error={errors.payment_Mode?.message} />}
                    {(props.singleData.paymentStatus === "Released" || props.singleData.paymentStatus === "Balance") && <JVInput column={3} label="Transaction ID" control={control} name="transaction_ID" error={errors.transaction_ID?.message} />}
                    <JVInput column={3} label="Remark" control={control} name="remarks" error={errors.remarks?.message} />
                    <div className="field col-12 md:col-2">
                        <span className="">Invoice <span style={{ color: 'red' }}>*</span></span>
                        <FileUpload className="mt-2" chooseLabel="Choose Invoice" mode="basic" name="invoice" accept=".pdf" customUpload auto uploadHandler={invoiceUpload} />
                    </div>
                    {/* {props.singleData?.invoiceNO && <div className="field col-12 md:col-2 pt-5">
                        <JVCheckbox label="Verify" control={control} name="isVerfied" />
                    </div>} */}
                    <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                        <Button className="field col-12 md:col-6 h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => {
                            if (props.singleData.id != null && props.singleData.id != 0) {
                                let subvendorID = {
                                    vendor_Company_ID: props.singleData.vendor_Company_ID,
                                    vendor_Company_Name: props.singleData.vendor_Company_Name,
                                };
                                let consultantID = {
                                    consultant_ID: props.singleData.consultant_ID,
                                    consultant_Name: props.singleData.consultant_Name + ` ( ${props.singleData.primeVendor_Company_Name} )`,
                                    pO_ID: props.singleData.pO_ID,
                                };

                                let invData: any = {
                                    id: props.singleData.id,
                                    invoiceNO: props.singleData.invoiceNO,
                                    invoiceAmount: props.singleData.invoiceAmount,
                                    primevendorInvoice_ID: props.singleData.primevendorInvoice_ID,
                                    pO_ID: props.singleData.pO_ID,
                                    fromDate: null,
                                    toDate: null,
                                    dueDate: null,
                                    recivedDate: null,
                                    consultant_ID: consultantID,
                                    requestedAmount: props.singleData.requestedAmount,
                                    workingHours: props.singleData.workingHours,
                                    subvendorCompany_ID: subvendorID,
                                    bRate: props.singleData.bRate,
                                    paymentStatus: props.singleData.paymentStatus,
                                    paidAmount: props.singleData.paidAmount,
                                    payment_Mode: props.singleData.payment_Mode,
                                    transaction_ID: props.singleData.transaction_ID,
                                };

                                // let data = getDates(); props.po && props.recent.pO_ID && props.po.sub_Vendor_Billing_Cycle
                                //props.po.prime_Vendor_Payment_Term

                                let singleData = invData;

                                let recent = props.recent;

                                let po = {
                                    pO_ID: props.singleData.pO_ID,
                                    sub_Vendor_Billing_Cycle: props.singleData.sub_Vendor_Billing_Cycle,
                                    prime_Vendor_Payment_Term: props.singleData.sub_Vendor_Payment_Term,
                                    project_Start_Date: props.singleData.project_Start_Date,
                                    project_End_Date: props.singleData.project_End_Date
                                };
                                // let data = getDates({ po, recent, singleData });

                                const values = getDates({ pO_ID: props?.recent?.pO_ID || null, toDate: props?.recent?.toDate ? new Date(props?.recent?.toDate || "") : null }, { Billing_Cycle: props.singleData.sub_Vendor_Billing_Cycle || null, Payment_Term: props.singleData.sub_Vendor_Payment_Term || null, project_Start_Date: new Date(props.singleData.project_Start_Date || ""), project_End_Date: new Date(props.singleData.project_End_Date || ""), timesheet_Week_Start_Day: (props.singleData.timesheet_Week_Start_Day ?? 0) });

                                invData.fromDate = values.FromDate;
                                invData.toDate = values.ToDate;
                                invData.dueDate = values.DueDate;

                                // invData.fromDate = data.fromDate;
                                // invData.toDate = data.toDate;
                                // invData.dueDate = data.dueDate;

                                reset(invData);
                            } else {
                                reset(EmptyForm);
                            }
                            setSvInvAmnt(0);
                            setPoDetails(null);
                            setDispFields({ Consultant: true, Primevendor: true });
                            setInvoiceFile(null);
                        }} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}


// const getDates2 = (props: IGetDateProps) => {
//     if (props.po && props.recent?.pO_ID && props.po.sub_Vendor_Billing_Cycle === "Monthly") {
//         if (props.recent?.toDate === null || props.recent?.toDate === undefined) {
//             var month = new Date(props?.po?.project_Start_Date || "");
//             var lastDayOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
//             props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
//             props.singleData.toDate = new Date(lastDayOfMonth.toString());
//             //var lastDayOfMonthNextMonth = new Date(month.getFullYear(), month.getMonth() + 2, 0);
//             //props.singleData.dueDate = new Date(lastDayOfMonthNextMonth.toString());
//             if (props.po.prime_Vendor_Payment_Term === "Net 30") {
//                 // props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 30));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
//                 props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(props.singleData?.invData || new Date()).getDate() + 45));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
//                 //props.singleData.dueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
//                 props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(props.singleData?.invData || new Date()).getDate() + 15));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
//                 props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(props.singleData?.invData || new Date()).getDate() + 60));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
//                 props.singleData.dueDate = new Date(new Date(new Date()).setDate(new Date(props.singleData?.invData || new Date()).getDate() + 7));
//             };

//             props.singleData.invoiceDate = new Date();

//         } else if (props.recent?.toDate !== null) {
//             // console.log(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear(), new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 1 : 1));
//             let getFromDateFullyear = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear();
//             let getFromDateMonth = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(props.recent.toDate || "").getMonth() + 1;

//             // props.singleData.fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getMonth() + 1));
//             props.singleData.fromDate = new Date(getFromDateFullyear, getFromDateMonth, 1);

//             var lastDayOfMonth = new Date(props.singleData.fromDate.getFullYear(), props.singleData.fromDate.getMonth() + 1, 0);
//             props.singleData.toDate = new Date(lastDayOfMonth.toString());
//             var lastDayOfMonthNextMonth = new Date(props.singleData.toDate.getFullYear(), props.singleData.toDate.getMonth() + 2, 0);
//             //props.singleData.dueDate = new Date(lastDayOfMonthNextMonth.toString());
//             if (props.po.prime_Vendor_Payment_Term === "Net 30") {
//                 // props.singleData.dueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(new Date(props.singleData?.invData || new Date())).getDate() + 30));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 45));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
//                 //props.singleData.dueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 15));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 60));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 7));
//             };
//             props.singleData.invoiceDate = new Date();
//         }
//     }
//     if (props.po && props.recent?.pO_ID && props.po.sub_Vendor_Billing_Cycle === "Weekly") {
//         if (props.recent?.toDate === null || props.recent?.toDate === undefined) {
//             props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
//             const currentDate = new Date(props?.po?.project_Start_Date || "");
//             let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay())) - 2;
//             const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
//             props.singleData.toDate = toDate;
//             props.singleData.invoiceDate = new Date();
//             //const dueDate = new Date((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).setDate((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).getDate() + 7));
//             if (props.po.prime_Vendor_Payment_Term === "Net 30") {
//                 props.singleData.dueDate = new Date(new Date(props.singleData?.invData || new Date()).getMonth() + 1 === 12 ? new Date(props.singleData?.invData || new Date()).getFullYear() + 1 : new Date(props.singleData?.invData || new Date()).getFullYear(), 1, 0);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 45))
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
//                 //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 15))
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 60))
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 7))
//             };
//             //props.singleData.dueDate = dueDate;
//         } else if (props.recent?.toDate !== null) {
//             // console.log(props.recent.toDate);
//             const fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 3));
//             props.singleData.fromDate = fromDate;
//             // console.log(props.singleData.fromDate);
//             const toDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 7));
//             props.singleData.toDate = toDate;
//             //const dueDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 14));
//             //props.singleData.dueDate = dueDate;
//             props.singleData.invoiceDate = new Date();
//             if (props.po.prime_Vendor_Payment_Term === "Net 30") {
//                 props.singleData.dueDate = new Date(new Date(props.singleData?.invData || new Date()).getMonth() + 1 === 12 ? new Date(props.singleData?.invData || new Date()).getFullYear() + 1 : new Date(props.singleData?.invData || new Date()).getFullYear(), 1, 0);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 45));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
//                 //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 15));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 60));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 7));
//             };
//         }
//     }
//     if (props.po && props.recent?.pO_ID && props.po.sub_Vendor_Billing_Cycle === "Bi-Weekly") {
//         if (props.recent?.toDate === null || props.recent?.toDate === undefined) {

//             props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
//             const currentDate = new Date(props?.po?.project_Start_Date || "");
//             let numberOfDaysToAdd = (7 - Number(new Date(props?.po?.project_Start_Date || "")?.getDay())) - 2;
//             const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 7)));

//             let toDateYear = props.singleData.fromDate.getFullYear();
//             let toDateMonth = props.singleData.fromDate.getMonth();
//             let toDateDay = props.singleData.fromDate.getDate() < 16 ? 15 : new Date(props.singleData.fromDate.getFullYear(), props.singleData.fromDate.getMonth(), 0).getDate() - 1;

//             props.singleData.toDate = new Date(toDateYear, toDateMonth, toDateDay);
//             props.singleData.invoiceDate = new Date();
//             //const dueDate = new Date((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).setDate((new Date(new Date(props?.po?.project_Start_Date || "").setDate(new Date(props?.po?.project_Start_Date || "").getDate() + numberOfDaysToAdd))).getDate() + 21));
//             //props.singleData.dueDate = dueDate;
//             if (props.po.prime_Vendor_Payment_Term === "Net 30") {
//                 props.singleData.dueDate = new Date(new Date(props.singleData?.invData || new Date()).getMonth() + 1 === 12 ? new Date(props.singleData?.invData || new Date()).getFullYear() + 1 : new Date(props.singleData?.invData || new Date()).getFullYear(), 1, 0);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 45));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
//                 //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 15));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 60));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 7));
//             };
//         } else if (props.recent?.toDate !== null) {
//             // console.log(new Date(new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear(), new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 1 : new Date(props.recent.toDate || "").getMonth(), 1));
//             let toDateYear = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? new Date(props.recent.toDate || "").getFullYear() + 1 : new Date(props.recent.toDate || "").getFullYear();
//             let toDateMonth = new Date(props.recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(props.recent.toDate || "").getMonth() + 1;
//             let toDateDay = new Date(props.recent.toDate || "").getDate() > 15 ? 1 : 16;

//             // const fromDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 3));
//             const fromDate = new Date(toDateYear, toDateMonth, toDateDay);

//             props.singleData.fromDate = fromDate;
//             const toDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() < 16 ? 15 : new Date(fromDate.getFullYear(), fromDate.getMonth(), 0).getDate());
//             //new Date(fromDate.getFullYear(), fromDate.getMonth(), 0).getDate()
//             props.singleData.toDate = toDate;
//             //const dueDate = new Date(new Date(props.recent.toDate || "").setDate(new Date(props.recent.toDate || "").getDate() + 35));
//             //props.singleData.dueDate = dueDate;
//             if (props.po.prime_Vendor_Payment_Term === "Net 30") {
//                 props.singleData.dueDate = new Date(new Date(props.singleData?.invData || new Date()).getMonth() + 1 === 12 ? new Date(props.singleData?.invData || new Date()).getFullYear() + 1 : new Date(props.singleData?.invData || new Date()).getFullYear(), 1, 0);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 45") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 45));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Pay on Pay") {
//                 //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 15") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 15));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 60") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 60));
//             }
//             else if (props.po.prime_Vendor_Payment_Term === "Net 7") {
//                 props.singleData.dueDate = new Date(new Date().setDate(new Date(props.singleData?.invData || new Date()).getDate() + 7));
//             };
//             props.singleData.invoiceDate = new Date();
//         }
//     }
//     if (new Date(props.singleData.toDate || "") > new Date(props.po.project_End_Date || "") && props.recent?.pO_ID) {
//         props.singleData.toDate = new Date(props.po.project_End_Date || "");
//         props.singleData.invoiceDate = new Date(props.po.project_End_Date || "");
//         props.singleData.dueDate = null;
//     }

//     return { fromDate: props.singleData.fromDate, toDate: props.singleData.toDate, invoiceDate: props.singleData.invoiceDate, dueDate: props.singleData.dueDate }
// }